/*
 * @Author: huangzq
 * @Date: 2020-08-21 17:41:22
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-08-28 14:32:41
 * @Desc: 第三方应用-手动授权方法
*/

import urlEncode from './url-encode'

const thirdAuth = (otherParams = {}, autoJump = true) => {
  // 主页应用地址配置
  // 参考地址：https://qw-scrm-dev2.dustess.com/spwork/v1/third_auth/login?suiteid=ww16cad2c6aefbc865&state=123&redirect=https%3A%2F%2Fmk-mesh-dev2.dustess.com%2F%23%2Fhome%3Fsuiteid%3Dww16cad2c6aefbc865&authtype=1&scope=snsapi_privateinfo

  /**
   * 地址配置说明：
   * 地址：location.origin(https://qw-scrm-dev2.dustess.com)+接口地址(/spwork/v1/third_auth/login)
   * 参数：
   *  suiteid: ww16cad2c6aefbc865,
   *  state: 123,
   *  redirect: encodeURIComponent(location.origin + '/#/home'),
   *  authtype: 1,
   *  scope: snsapi_privateinfo,
   */

  let authUrl = `${window.location.origin}/spwork/v1/third_auth/login`

  const urlParams = {
    suiteid: 'ww16cad2c6aefbc865',
    state: 123,
    redirect: encodeURIComponent(`${window.location.origin}/#/home`),
    authtype: 1,
    scope: 'snsapi_privateinfo',
    ...otherParams,
  }

  const urlEncodeParams = urlEncode(urlParams).replace('&', '?')

  authUrl += urlEncodeParams

  if (autoJump)
    window.location.replace(authUrl)

  return authUrl
}

export default thirdAuth
